import { useState, useEffect } from 'react';
import { SearchBar } from '@/components/ui/search-bar';
import { useSearchEvents } from '@/lib/hooks/useEvents';
import type { Event } from '@/lib/types/database';

interface EventsSearchProps {
  onSearchChange: (
    query: string,
    results: Event[],
    isLoading: boolean
  ) => void;
}

/**
 * Events-specific search component that wraps the base SearchBar.
 * Manages search state and integrates with the useSearchEvents hook.
 * Reports search state changes to the parent component via callback.
 */
export function EventsSearch({ onSearchChange }: EventsSearchProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const { data: searchResults, isPending } = useSearchEvents(searchQuery);

  // Notify parent of search state changes
  useEffect(() => {
    onSearchChange(searchQuery, searchResults || [], isPending);
  }, [searchQuery, searchResults, isPending, onSearchChange]);

  return (
    <div data-testid="events-search">
      <SearchBar
        value={searchQuery}
        onChange={setSearchQuery}
        placeholder="Search events"
      />
    </div>
  );
}

